import { Dialog as DialogPrimitive } from "radix-ui";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/Icon";

/** Cada acao do card confirma num popup proprio, com titulo, corpo e label distintos. */
export type ConsentDialogVariant = "revoke_all" | "save_changes" | "authorize";

type ConsentActionDialogProps = {
  open: boolean;
  variant: ConsentDialogVariant;
  clientName: string;
  loading?: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
};

export default function ConsentActionDialog({
  open,
  variant,
  clientName,
  loading,
  onOpenChange,
  onConfirm,
}: ConsentActionDialogProps) {
  const { t } = useTranslation();

  const base = `site_credentials.consents.dialogs.${variant}`;

  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/40" />
        <DialogPrimitive.Content
          className="fixed left-1/2 top-1/2 z-50 flex w-[calc(100%-2rem)] max-w-[42ch] -translate-x-1/2 -translate-y-1/2 flex-col gap-12 rounded-lg bg-[var(--surface-default)] p-16 shadow-lg focus:outline-0"
          aria-describedby={undefined}
        >
          <div className="flex items-start justify-between gap-8">
            <DialogPrimitive.Title className="text-lg font-bold text-[var(--on-surface-default)]">
              {t(`${base}.title`)}
            </DialogPrimitive.Title>
            <DialogPrimitive.Close
              aria-label={t("site_credentials.consents.dialogs.close")}
              className="shrink-0 cursor-pointer focus:outline-0 focus-visible:ring-2 focus-visible:ring-[var(--outline-others-focus)]"
            >
              <Icon name="StreamlineEssentialCloseRegular" size="sm" className="text-[var(--on-surface-variant)]" />
            </DialogPrimitive.Close>
          </div>

          <p
            className="text-sm text-[var(--on-surface-default)]"
            dangerouslySetInnerHTML={{ __html: t(`${base}.body`, { clientName }) }}
          />

          <div className="flex justify-end gap-8">
            <Button
              type="button"
              variant="secondary"
              size="sm"
              disabled={loading}
              className="min-w-0 rounded-full px-12"
              onClick={() => onOpenChange(false)}
            >
              {t("site_credentials.consents.dialogs.cancel")}
            </Button>
            <Button
              type="button"
              size="sm"
              disabled={loading}
              className="min-w-0 rounded-full px-12"
              onClick={onConfirm}
            >
              {t(`${base}.confirm`)}
            </Button>
          </div>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
